/** Canonical GHG inventory calculation contract — shared types (CP-WP-016). */

export const CANONICAL_GHG_CONTRACT_VERSION = 'cp-ghg-contract-2.0.0';
export const CANONICAL_GHG_CONTRACT_PRIOR_VERSION = 'cp-ghg-contract-1.0.0';

export type SectorId =
  | 'stationary_energy_electricity_residential'
  | 'stationary_energy_electricity_commercial'
  | 'stationary_energy_natural_gas_residential'
  | 'stationary_energy_natural_gas_commercial'
  | 'transportation_light_duty'
  | 'transportation_heavy_duty'
  | 'solid_waste'
  | 'wastewater'
  | 'offroad'
  | 'agriculture';

export type SectorValueStatus =
  | 'measured'
  | 'calculated'
  | 'estimated'
  | 'unavailable'
  | 'not_applicable'
  | 'provisional';

export type ResultPath = 'live' | 'precalculated_cache' | 'published_snapshot';

/** Chris directive §4 — inventory completeness states. */
export type InventoryCompletenessState =
  | 'complete'
  | 'complete_with_estimates'
  | 'partial';

export interface SectorYearValue {
  year: number;
  sectorId: SectorId;
  displayCategory: string;
  emissionsMt: number | null;
  status: SectorValueStatus;
  activityValue?: number | null;
  activityUnits?: string;
  emissionFactor?: number | null;
  factorVintageYear?: number | null;
  methodVersion?: string | null;
  source?: string;
  sourceDataYear?: number | null;
  estimationMethod?: string | null;
  notes?: string;
}

export interface InventoryYearTotals {
  year: number;
  sectorValues: SectorYearValue[];
  /** Sum of sectors with numeric emissions only; unavailable sectors excluded from sum. */
  totalMt: number | null;
  completenessState: InventoryCompletenessState;
  /** @deprecated Use completenessState === 'complete' */
  completeInventory: boolean;
  missingSectors: SectorId[];
  estimatedSectors: SectorId[];
  wastewaterIncludedInTotal: boolean;
}

export interface SolidWasteContext {
  geofips: number | string;
  countyGeofips: number | null;
  geographyType?: string | null;
  countyName?: string | null;
}
